import { render, staticRenderFns } from "./reformSapList.vue?vue&type=template&id=3b7ced5a"
import script from "./reformSapList.vue?vue&type=script&lang=js"
export * from "./reformSapList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports